export default __webpack_public_path__ + "static/media/lamp.6dcda55d.svg";